import { render, staticRenderFns } from "./dataTime.vue?vue&type=template&id=884da0de&"
import script from "./dataTime.vue?vue&type=script&lang=js&"
export * from "./dataTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports